"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var contact_1 = __importStar(require("./contact"));
var restful_model_collection_1 = __importDefault(require("./restful-model-collection"));
var ContactRestfulModelCollection = /** @class */ (function (_super) {
    __extends(ContactRestfulModelCollection, _super);
    function ContactRestfulModelCollection(connection) {
        var _this = _super.call(this, contact_1.default, connection) || this;
        _this.connection = connection;
        _this.modelClass = contact_1.default;
        return _this;
    }
    ContactRestfulModelCollection.prototype.groups = function (callback) {
        return this.connection
            .request({
            method: 'GET',
            path: "/contacts/groups",
        })
            .then(function (json) {
            var groups = json.map(function (group) {
                return new contact_1.Group().fromJSON(group);
            });
            if (callback) {
                callback(null, groups);
            }
            return Promise.resolve(groups);
        })
            .catch(function (err) {
            if (callback) {
                callback(err);
            }
            return Promise.reject(err);
        });
    };
    return ContactRestfulModelCollection;
}(restful_model_collection_1.default));
exports.default = ContactRestfulModelCollection;
